import React from 'react';
import PropTypes from 'prop-types';

import SideMenu from '../sideMenu/SideMenu';

import cx from 'classnames';

import ChannelLink from '../../containers/channelUtils/ChannelLink';

export default class CategoryMenuGames extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {isMenuOpen: false};
  }

  render() {
    const {isMenuOpen} = this.state;
    const {items, active, onItemClick} = this.props;

    const activeItem = items.find(it => it.value === active) || items[0];

    return (
      <div className={cx(
        'category-menu',
        isMenuOpen && 'category-menu--open'
      )}>
        <a className="category-menu__title" href="#" onClick={evt => {
          evt.preventDefault();
          this.setState({isMenuOpen: true});
        }}>
          {activeItem.name}
        </a>

        <SideMenu
          isOpen={isMenuOpen}
          onStateChange={isMenuOpen => this.setState({isMenuOpen})}
        >
          <div className="side-menu__wrap">
            <div className="side-menu__nav">
              {items.map(item => (
                <ChannelLink
                  key={item.name}
                  to="#"
                  className="side-menu__link"
                  onClick={e => {
                    e.preventDefault();
                    onItemClick(item.value);
                    this.setState({isMenuOpen: false})
                  }}
                >
                  {item.name}
                </ChannelLink>
              ))}
            </div>
          </div>
        </SideMenu>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/categoryMenu/CategoryMenuGames.js